// const ENDPOINT_URL =
//   window.location.hostname === "localhost"
//     ? "http://localhost:5000"
//     : "https://incubator.drishticps.org";

// export default ENDPOINT_URL;

const ENDPOINT_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "";

export default ENDPOINT_URL;
